// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"c3ed9507","75":"5c836ce6","113":"5aeb5b8a","114":"12dd75bb","178":"d728b708","191":"5b15a216","198":"a70383a1","319":"4842aa91","453":"68693753","538":"bd36a865","555":"b82324ac","718":"67cf272c","818":"82c455fc","831":"cd197ade","927":"8e03fc78"}[chunkId] + ".chunk.js";
};